<div class="{{parentClass}}" [formGroup]="phoneGroup" [ngClass]="{'has-error invalid': showErrorLabel && phoneGroup.dirty && phoneGroup.errors}">
  <p class="field-label" *ngIf="showLabel">{{label}} <span *ngIf="required" class="field-mandatory">*</span></p>
  <div class="field-input phone-code" [ngClass]="{'readonly': readOnly}" #phoneCodeGroup>
    <div class="country-codes tel-input-box">
      <input type="hidden" formControlName="country_code">
      <div
        class="country-value dropdown-toggle"
        [ngClass]="{'open': showDropdown}"
        (click)="dropdownClick(phoneCodeGroup)"
        data-bs-toggle="dropdown"
        [attr.aria-expanded]="showDropdown"
        role="button"
        tabindex="0">
        <ng-container *ngIf="getSelectedCountry()?.short_code as selectedShortCode">
          <img
            *ngIf="shouldUseFlagImage(selectedShortCode); else selectedFlagFallback"
            class="country-flag"
            [src]="getCountryFlagImageUrl(selectedShortCode)"
            [alt]="selectedShortCode + ' flag'"
            loading="lazy"
            decoding="async"
            (error)="onFlagImageError($event, selectedShortCode)">
          <ng-template #selectedFlagFallback>
            <span class="country-flag-fallback">{{ selectedShortCode }}</span>
          </ng-template>
        </ng-container>
        <span class="country-code-text">{{ country_code?.value }}</span>
      </div>
      <div class="dropdown-menu" [ngClass]="{'show': showDropdown && !readOnly}">
        <ul class="location-list">
          <li class="search">
            <input class="country-filter-input" type="text" #countryCodeSearchInput (input)="searchCountryCodes($event)" placeholder="Search by country or code">
          </li>
          <ng-container *ngFor="let country of getCountryCodes()">
            <li class="dropdown-item" (click)="selectCountry(country)" [ngClass]="{'selected': country.code === country_code?.value}">
              <img
                *ngIf="shouldUseFlagImage(country.short_code); else optionFlagFallback"
                class="country-flag"
                [src]="getCountryFlagImageUrl(country.short_code)"
                [alt]="country.short_code + ' flag'"
                loading="lazy"
                decoding="async"
                (error)="onFlagImageError($event, country.short_code)">
              <ng-template #optionFlagFallback>
                <span class="country-flag-fallback">{{ country.short_code }}</span>
              </ng-template>
              <span>{{country.country}} ({{country.code}})</span>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <input
      #phoneInput
      type="tel"
      name="phone-value"
      inputmode="tel"
      autocomplete="tel"
      (click)="focusPhoneInput()"
      (keydown)="restrictToNumbers($event)"
      [readonly]="readOnly"
      class="phone-value"
      formControlName="phone_number"
      appFocusClass>
  </div>
  <p class="error-message" *ngIf="parentClass === 'field-type-1' && showErrorLabel && phoneGroup.dirty && phoneGroup.errors">
    <ng-container *ngIf="phoneGroup.errors['areacode']">
      Invalid phone number, check if area code is missing
    </ng-container>
    <ng-container *ngIf="phoneGroup.errors['invalid']">
      Please enter valid phone number
    </ng-container>
  </p>
  <ul class="errors" *ngIf="parentClass === 'field-type-2' && showErrorLabel && phoneGroup.dirty && phoneGroup.errors">
    <li *ngIf="phoneGroup.errors.areacode">Invalid phone number, check if area code is missing</li>
    <li *ngIf="phoneGroup.errors.invalid">Please enter valid phone number</li>
  </ul>
</div>
